import List from './components/List'
import Form from './components/Form'

export default [
  {path: '/field', component: List, name: 'field.index'},
  {path: '/field/store', component: Form, name: 'field.store'},
  {path: '/field/:id', component: Form, name: 'field.update'}
]



// WEBPACK FOOTER //
// ./src/app/domains/field/routes.js